import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loading from 'components/Loading';
import StoreCard from './components/storeCard';
import MessageBox from 'components/MessageBox';
import { requestAllStores, navigate } from 'actionCreators';
import { getRole, getStoreList, getStoreLoading } from '../../../../reducers';
import ui from 'redux-ui';
import StoreType from 'types/store';

class StoreList extends Component {
  static propTypes = {
    updateUI: PropTypes.func.isRequired,
    requestAllStores: PropTypes.func.isRequired,
    navigate: PropTypes.func.isRequired,
    ui: PropTypes.shape({
      successMessage: PropTypes.string,
    }),
    stores: PropTypes.arrayOf(StoreType).isRequired,
    role: PropTypes.string,
    loading: PropTypes.bool,
  }

  componentDidMount() {
    this.props.requestAllStores();
  }

  componentWillUnmount() {
    if (this.props.ui.successMessage) {
      this.props.updateUI('successMessage', '');
    }
  }

  viewAction = id => this.props.navigate(`/stores/${id}`);

  render() {
    const { stores, role, loading } = this.props;

    return (
      <div>
        {this.props.ui.successMessage && <MessageBox message={this.props.ui.successMessage} />}
        {loading && <Loading message="Loading stores..." />}
        {stores.map(store =>
          <StoreCard
            key={`store-${store.id}`}
            role={role}
            store={store}
            onSelect={this.viewAction}
          />,
        )}
        {!loading && stores.length === 0 && 'Your search yielded no results.'}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  stores: getStoreList(state),
  loading: getStoreLoading(state),
  role: getRole(state),
});

export default ui()(connect(
  mapStateToProps, { requestAllStores, navigate },
)(StoreList));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/stores/storeList.jsx